// @ts-expect-error Tools file is in JS
import Tools from '../Tools/Tools';

type MessageType = 'warning';

/**
 * Singleton!
 * Třída zobrazující zprávu uživateli nad stránkou.
 */
export default class Message {
	static #instance: Message | null = null;

	#boxHeight = 6; // rem
	#destructionTimeout = 5000; // ms;
	#destructionAnimationTimeout = 800; // ms;

	constructor() {
		if (!Message.#instance) {
			Message.#instance = this;

			return this;
		}

		return Message.#instance;
	}

	show(
		type: MessageType = 'warning',
		// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Introduced in TP-9489.
		text: string = window.SSP.translations.messages.error,
	) {
		this.#restrictMessagesCount();
		this.#createMessage(type, text);
	}

	#hide = (event: Event) => {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access -- Introduced in TP-10066.
		const msgElement = Tools.getParentByClass(
			event.target,
			'Message--floating',
		);

		if (msgElement) {
			// eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- Introduced in TP-10066.
			this.#removeMessage(msgElement);
		}
	};

	/**
	 * Zobrazuji maximálně 3 zprávy, pokud jich je víc, tak poslední odstraním.
	 */
	#restrictMessagesCount() {
		const messages = Array.from(
			document.querySelectorAll<HTMLDivElement>(
				'.Message--floating:not(.is-deleted)',
			),
		);

		if (messages.length >= 3) {
			const lastMessage = messages[messages.length - 1];

			if (lastMessage) {
				this.#removeMessage(lastMessage);
			}
		}
	}

	/**
	 * Msg se po N vteřinách zničí.
	 */
	#setMessageDestructor(msgElement: HTMLDivElement) {
		setTimeout(() => {
			this.#removeMessage(msgElement);
		}, this.#destructionTimeout);
	}

	/**
	 * Pro vytvoření animace je prvek nejdříve přesunut mimo obrazovku
	 * a potom odstraněn.
	 */
	#removeMessage(msgElement: HTMLDivElement) {
		msgElement.style.top = '-6rem';
		msgElement.style.zIndex = '100';
		msgElement.classList.add('is-deleted');

		setTimeout(() => {
			// eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access -- Introduced in TP-10066.
			Tools.removeElement(msgElement);
		}, this.#destructionAnimationTimeout);

		this.#moveMessages();
	}

	/**
	 * Posune zprávy na správné pozice.
	 */
	#moveMessages() {
		const messages = Array.from(
			document.querySelectorAll<HTMLDivElement>(
				'.Message--floating:not(.is-deleted)',
			),
		);

		messages.forEach((message, index) => {
			// eslint-disable-next-line @typescript-eslint/restrict-plus-operands -- Introduced in TP-10066.
			message.style.top = this.#boxHeight * index + 'rem';
		});
	}

	/**
	 * Vytvoří zprávu a umístí jí do DOMu.
	 */
	#createMessage(type: MessageType, text: string) {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access -- Introduced in TP-10066.
		const msgElement = Tools.createElement('div', {
			// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- Introduced in TP-9489.
			class: 'Message Message--floating' + (type ? ' Message--' + type : ''),
		});

		// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access -- Introduced in TP-10066.
		const textElement = Tools.createElement('div', {
			class: 'Message-text',
			innerText: text,
		});

		// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access -- Introduced in TP-10066.
		const closeButton = Tools.createElement('div', { class: 'Message-close' });

		// eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access -- Introduced in TP-9489 and TP-10066.
		closeButton.addEventListener('click', this.#hide);
		// eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access -- Introduced in TP-10066.
		Tools.appendChilds(msgElement, textElement, closeButton);

		const pageHeader = document.querySelector('.Page-header');

		// eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access -- Introduced in TP-10066.
		Tools.insertAfter(msgElement, pageHeader);
		// Donutím prohlížeš přepočítat pozici a umožním prvotní animaci.
		this.#moveMessages();
		// eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- Introduced in TP-10066.
		this.#setMessageDestructor(msgElement);
	}
}
